<template>
  <v-dialog
    v-model="showWindow"
    scrollable
    max-width="1000"
    max-height="90%"
    min-width="600px"
  >
    <v-card height="100%" :loading="!fetched">
      <v-card-text class="pt-5">
        <h2 class="pa-3 pt-2">{{ $t("common.messages") }}</h2>
        <table
          class="mx-3 overflow-y-auto"
          style="max-height: 200px; display: block"
        >
          <tr v-for="item in messages" class="px-3 pb-2">
            <td class="text-no-wrap" valign="top">
              {{ item.created_at | moment("DD.MM.YYYY") }}
              <br/>
              {{ item.created_at | moment("HH:mm") }}
            </td>
            <td class="text-no-wrap" valign="top">
              <b>[{{ item.user.name }}]</b>
            </td>
            <td class="text-no-wrap" valign="top">
              <b>[{{ item.user.name }}]
              </b>
              <i v-if="item.is_phone" class="fa fa-mobile" aria-hidden="true" title="SMS"></i>
              <span v-if="item.is_phone" > ({{item.contact_value}}):</span>
              <i v-if="item.is_email" class="fa fa-envelope" aria-hidden="true" title="E-mail"></i>
              <span v-if="item.is_email" > ({{item.contact_value}}):</span>
            </td>
            <td>
              {{item.text}}
            </td>
          </tr>
        </table>

        <v-layout class="px-3 pb-2">
          <v-row>
            <v-col cols="12">
              <v-textarea
                outlined
                v-model="message.text"
                :label="$t('common.text')"
                :loading="isLoading"
              ></v-textarea>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      elevation="0"
                      class="mt-4"
                      v-on="on"
                      :title="$t('common.documents')"
                      :loading="isLoading"
                  >
                    <v-icon x-small>fa-chevron-down</v-icon>
                    {{ $t('viewSettings.sms_templates.title') }}
                  </v-btn>
                </template>
                <v-list offset-y>
                  <v-list-item
                      v-for="template in smsTemplates.filter(
                        (el) => el.type === 'personal'
                      )"
                  >
                    <v-list-item-title class="pointer" @click="applySmsTemplate(template)">
                      {{template.name}}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-checkbox v-model="message.is_phone" label="SMS"> </v-checkbox>
            </v-col>
            <v-col cols="3" class="py-0">
              <v-checkbox v-model="message.is_email" label="E-mail" :disabled="isDisabledEmail"> </v-checkbox>
            </v-col>
            <v-col cols="3" class="text-right px-0 py-0">
              <v-btn
                :disabled="!(message.text && message.text.length > 3) || (!message.is_phone && !message.is_email )"
                :loading="savingInProgress"
                class="mr-2 mt-4"
                color="primary"
                elevation="0"
                @click="send"
              >
                {{ $t("common.send") }}
              </v-btn></v-col
            >
          </v-row>
        </v-layout>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import CommonMixin from "@/mixins/common";

export default {
  name: "CustomerMessagesWindow",
  mixins: [CommonMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customer: null,
  },
  data: () => ({
    message:{
      text:null,
      is_email:false,
      is_phone:false,
      customer:null,
    }
  }),
  mounted() {},
  computed: {
    ...mapFields("sms_templates", ["smsTemplates", "isLoading"]),
    ...mapFields("customer_messages", ["fetched", "savingInProgress", "messages"]),
    isDisabledEmail(){
      if(!this.customer){
        return true
      }
      if(!this.customer.email || this.customer.email.trim() === ''){
        return true
      }
      return false;
    },
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  methods: {
    async send(){
      return await this.$store.dispatch("customer_messages/store",
          this.message
      )
    },
    async applySmsTemplate(template){
      return await this.$store.dispatch("sms_templates/applyTemplateForCustomer",
          {
            customer_id: this.customer.id,
            template_id: template.id
          }
      ).then((text)=>{
        this.message.text = text;
      })
    }
  },
  watch: {
    showWindow(value) {
      if (value && this.customer.id>0) {
        this.message.text = null;
        this.message.customer = this.customer;
        this.message.is_phone = false;
        this.message.is_email = false;
        this.$store.dispatch("customer_messages/get", { customer_id: this.customer.id });
        this.$store.dispatch("sms_templates/get");
      }
    },
  },
};
</script>
<style type="css">

</style>
